import { render, staticRenderFns } from "./ViewAvaliacao.vue?vue&type=template&id=ef1e812e&scoped=true"
import script from "./ViewAvaliacao.vue?vue&type=script&lang=js"
export * from "./ViewAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./ViewAvaliacao.vue?vue&type=style&index=0&id=ef1e812e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1e812e",
  null
  
)

export default component.exports